// extracted by mini-css-extract-plugin
module.exports = {"no_select_input":"Form_no_select_input__nC9ot"};